"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('moving-picture', true, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "6",
    y: "22",
    width: "20",
    height: "20",
    rx: "3",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 6L42 6L42 18",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "34",
    cy: "42",
    r: "1.5",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    r: "1.5",
    transform: "matrix(1 0 0 -1 6 14)",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42",
    cy: "42",
    r: "1.5",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    r: "1.5",
    transform: "matrix(1 0 0 -1 6 6)",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42",
    cy: "34",
    r: "1.5",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    r: "1.5",
    transform: "matrix(1 0 0 -1 14 6)",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42",
    cy: "26",
    r: "1.5",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    r: "1.5",
    transform: "matrix(1 0 0 -1 22 6)",
    fill: props.colors[0],
    stroke: props.colors[0]
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 34L12.1195 29.4103C13.2239 28.5821 14.7509 28.6143 15.8192 29.4885L25 37",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 6L30 18",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;